export const COLLABORATORS_ROUTES = {
  accept: { path: '/:eventHandle/collaborators/accept/:inviteUUID', goTo: (eventHandle: string, inviteUUID: string) => `/${eventHandle}/collaborators/accept/${inviteUUID}` },
};
